<div class="repair-progress-container">
  <div class="progress-buckets">
    <div class="bucket">
      <div class="bucket-title">
        <div class="title-1">Scheduled</div>
        <mat-divider />
      </div>
      @for (job of buckets().REPAIR_BOOKED; track job.jobId) {
        <app-job-card [job]="job" (updateBuckets)="updateBuckets.emit($event)" [bucket]="'REPAIR_BOOKED'" />
      }
    </div>
    <div class="bucket">
      <div class="bucket-title">
        <div class="title-1">Vehicle In</div>
        <mat-divider />
      </div>
      @for (job of buckets().VEHICLE_IN; track job.jobId) {
        <app-job-card [job]="job" (updateBuckets)="updateBuckets.emit($event)" [bucket]="'VEHICLE_IN'" />
      }
    </div>
    <div class="bucket">
      <div class="bucket-title">
        <div class="title-1">Repairs Started</div>
        <mat-divider />
      </div>
      @for (job of buckets().REPAIR_STARTED; track job.jobId) {
        <app-job-card [job]="job" (updateBuckets)="updateBuckets.emit($event)" [bucket]="'REPAIR_STARTED'" />
      }
    </div>
    <div class="bucket">
      <div class="bucket-title">
        <div class="title-1">Repairs Completed</div>
        <mat-divider />
      </div>
      @for (job of buckets().REPAIR_COMPLETED; track job.jobId) {
        <app-job-card [job]="job" (updateBuckets)="updateBuckets.emit($event)" [bucket]="'REPAIR_COMPLETED'" />
      }
    </div>
    <div class="bucket">
      <div class="bucket-title">
        <div class="title-1">Vehicle Out</div>
        <mat-divider />
      </div>
      @for (job of buckets().VEHICLE_OUT; track job.jobId) {
        <app-job-card [job]="job" (updateBuckets)="updateBuckets.emit($event)" [bucket]="'VEHICLE_OUT'" />
      }
    </div>
  </div>
</div>
